import React, { useCallback } from 'react';
import { Alert } from 'components';
import { useMutation } from '@tanstack/react-query';
import { generateVersionsFetch } from 'store/middlewares/assessment.crud';

interface CreateVersionPopupProps {
    handleAlert: (isOpen: boolean) => void;
}

const CreateVersionPopup: React.FC<CreateVersionPopupProps> = ({
    handleAlert
}) => {

    const { mutateAsync: generateVersions, isPending } = useMutation({
        mutationFn: generateVersionsFetch
    })


    const actionBtns = [
        {
            label: "צור גרסא עבור כל מבדקי המערכת",
            action: () => {
                generateVersions()
                handleAlert(false);
            },
            color: "light",
            isLoading: isPending
        },
        {
            label: `צור גרסא עבור המבדקים שנבחרו)`,
            action: () => {
                handleAlert(false);
            },
            color: "dark",
            disabled: true,
            disabledColor: "dark"
            // disabled: selectedTestsCount === 0 
        }
    ];

    return (
        <Alert
            title="יצירת גרסא"
            footerActions={actionBtns}
            handleAlert={() => handleAlert(false)}
        >
            <div>
                <p>בחר את אופן יצירת הגרסא.</p>
                <p>האם תרצה ליצור גרסא לכל המבדקים הקיימים במערכת, או רק לאלו שבחרת?</p>
            </div>
        </Alert>
    );
}

export default CreateVersionPopup;